import initStore from "../store"

const store = initStore()

export default store
